/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guest_Book_Sent_CloseInputs */

const en_guest_book_sent_close = /** @type {(inputs: Guest_Book_Sent_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Done`)
};

const pl_guest_book_sent_close = /** @type {(inputs: Guest_Book_Sent_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gotowe`)
};

/**
* | output |
* | --- |
* | "Done" |
*
* @param {Guest_Book_Sent_CloseInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const guest_book_sent_close = /** @type {((inputs?: Guest_Book_Sent_CloseInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guest_Book_Sent_CloseInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_guest_book_sent_close(inputs)
	return en_guest_book_sent_close(inputs)
});